import { MODALS } from "../AppModals/modals.constants";
import ManageUserModal from "./UsersModals/ManageUserModal";
import ManageUserRoleModal from "./UsersModals/ManageUserRoleModal";
import LandingModal from "./DataModelModals/LandingModal";
import FilterDataModal from "./FilterDataModal/FilterDataModal";
import CollectionSchemaModal from "./DataModelModals/CollectionSchemaModal";
import NodeDescriptionModal from "./ServiceModals/NodeDescriptionModal";
import ManageBillingModal from "./UsersModals/ManageBillingModal";
import ManageServiceModal from "./DataModelModals/ManageServiceModal";
import DeployMulesoftEndpointsModal from "./DeployBEModel/DeployMulesoftEndpointsModal";
import AddSecretsModal from "./DataModelModals/AddSecretsModal";
import FilterOrganizationsModal from "./FilterOrganizationsModal/FilterOrganizationsModal";
import UpdatePasswordModal from "./UsersModals/UpdatePasswordModal";
import DevConsoleModal from "./DevConsoleModal/DevConsoleModal";
import ComingSoonModal from "../ComingSoonModal";
import TransferOwnershipModal from "./UsersModals/TransferOwnershipModal";
import TemplateCreationModal from "./DataModelModals/TempalteCreationModal";
import EndpointTemplateModal from "./DataModelModals/EndpointTemplateModal";
import FileImportProgressModal from "./DataModelModals/FileImportProgressModal";
import CreateCollectionModal from "./DataModelModals/CreateCollectionModal";
import ImportFromDataModal from "./DataModelModals/ImportFromDataModal";

const {
  MANAGE_USER_MODAL,
  MANAGE_USER_ROLE_MODAL,
  LANDING_MODAL,
  FILTER_DATA_MODAL,
  COLLECTION_SCHEMA_MODAL,
  NODE_DESCRIPTION_MODAL,
  MANAGE_BILLING_MODAL,
  MANAGE_SERVICE_MODAL,
  DEPLOY_MULESOFT_ENDPOINTS_MODAL,
  ADD_SECRETS_MODAL,
  FILTER_ORGANIZATIONS_MODAL,
  UPDATE_PASSWORD_MODAL,
  DEV_CONSOLE_MODAL,
  COMING_SOON_MODAL,
  TRANSFER_OWNERSHIP_MODAL,
  CREATE_TEMPLATE_MODAL,
  ENDPOINT_TEMPLATE_MODAL,
  FILE_IMPORT_MODAL,
  CREATE_COLLECTION_MODAL,
  IMPORT_DATAMODAL_MODAL,
} = MODALS;

const renderModal = (name) =>
  ({
    [MANAGE_USER_MODAL]: <ManageUserModal />,
    [MANAGE_USER_ROLE_MODAL]: <ManageUserRoleModal />,
    [LANDING_MODAL]: <LandingModal />,
    [FILTER_DATA_MODAL]: <FilterDataModal />,
    [COLLECTION_SCHEMA_MODAL]: <CollectionSchemaModal />,
    [NODE_DESCRIPTION_MODAL]: <NodeDescriptionModal />,
    [MANAGE_BILLING_MODAL]: <ManageBillingModal />,
    [MANAGE_SERVICE_MODAL]: <ManageServiceModal />,
    [DEPLOY_MULESOFT_ENDPOINTS_MODAL]: <DeployMulesoftEndpointsModal />,
    [ADD_SECRETS_MODAL]: <AddSecretsModal />,
    [FILTER_ORGANIZATIONS_MODAL]: <FilterOrganizationsModal />,
    [UPDATE_PASSWORD_MODAL]: <UpdatePasswordModal />,
    [DEV_CONSOLE_MODAL]: <DevConsoleModal />,
    [COMING_SOON_MODAL]: <ComingSoonModal />,
    [TRANSFER_OWNERSHIP_MODAL]: <TransferOwnershipModal />,
    [CREATE_TEMPLATE_MODAL]: <TemplateCreationModal />,
    [ENDPOINT_TEMPLATE_MODAL]: <EndpointTemplateModal />,
    [FILE_IMPORT_MODAL]: <FileImportProgressModal />,
    [CREATE_COLLECTION_MODAL]: <CreateCollectionModal />,
    [IMPORT_DATAMODAL_MODAL]: <ImportFromDataModal />,
  }[name] || null);

export default renderModal;
